module.exports = __webpack_public_path__ + "img/banner.614ca107.png";